import { PLAY_TYPE } from '@/types/dtos/player/request/control-device.dto';

const PLAY_TYPE_BY_COMPOSITE_SLUG: Record<string, (typeof PLAY_TYPE)[keyof typeof PLAY_TYPE]> = {
  'flow-title': PLAY_TYPE.FLOW_INFO,
};

const IDENTITY_PLAY_TYPE_SLUGS = new Set<string>([
  PLAY_TYPE.EVENT_INFO,
  PLAY_TYPE.EVENT_CLOSING,
  PLAY_TYPE.FLOW_INFO,
  PLAY_TYPE.FLOW_CLOSING,
  PLAY_TYPE.FLOW_AGENDA,
  PLAY_TYPE.SESSION_INFO,
  PLAY_TYPE.BREAK_INFO,
]);

/** composite / virtualMedia slug → control preview playType. */
export function resolvePlayTypeForCompositeSlug(slug: string): (typeof PLAY_TYPE)[keyof typeof PLAY_TYPE] {
  if (PLAY_TYPE_BY_COMPOSITE_SLUG[slug]) {
    return PLAY_TYPE_BY_COMPOSITE_SLUG[slug]!;
  }
  if (IDENTITY_PLAY_TYPE_SLUGS.has(slug)) {
    return slug as (typeof PLAY_TYPE)[keyof typeof PLAY_TYPE];
  }
  return PLAY_TYPE.FLOW_INFO;
}

const LEGACY_CANONICAL_COMPOSITE_SLUG: Record<string, string> = {
  'flow-title': 'flow-info',
};

/** Legacy slug equivalence for cue row matching during flow-title → flow-info migration. */
export function canonicalCompositeSlug(slug: string): string {
  return LEGACY_CANONICAL_COMPOSITE_SLUG[slug] ?? slug;
}

export function compositeCueItemIdsEquivalent(a: string, b: string): boolean {
  if (a === b) {
    return true;
  }
  const slugA = a.startsWith('composite:') ? a.slice('composite:'.length) : null;
  const slugB = b.startsWith('composite:') ? b.slice('composite:'.length) : null;
  if (!slugA || !slugB) {
    return false;
  }
  return canonicalCompositeSlug(slugA) === canonicalCompositeSlug(slugB);
}
